import {
  EInvitationStatus,
  IInvitation,
  JupiterTheme,
  useInviteClient,
  useSnackbarNotification,
} from '@jupiterone/jupiter-web-toolkit';
import { List, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import InvitationListItem from 'navbar/src/jupiterAccountSettings/AccountSettings/Invitation/InvitationListItem';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    subHeader: {
      marginTop: theme.spacing(5),
    },
  })
);

interface Props {
  classes: any;
  invitations: IInvitation[];
  onUpdateInvitations: (
    invitation: IInvitation,
    action: 'remove' | 'add'
  ) => void;
}

const InvitationsTab = ({
  invitations,
  onUpdateInvitations,
  ...props
}: Props) => {
  const classes = useStyles();
  const notifications = useSnackbarNotification();
  const { inviteAction } = useInviteClient();
  const revokeInvite = async (
    invitation: IInvitation,
    _action: EInvitationStatus
  ) => {
    await inviteAction(invitation.id, EInvitationStatus.revoked);
    onUpdateInvitations(invitation, 'remove');
    notifications.success('Invitation revoked', 3000);
  };

  return (
    <>
      <Typography
        className={clsx(props.classes.tabHeader, classes.subHeader)}
        variant="subtitle1"
        color="primary"
      >
        Sent Invitations
      </Typography>
      <List>
        {invitations.map((invite: IInvitation) => (
          <InvitationListItem
            key={invite.id}
            invitation={invite}
            onInviteAction={revokeInvite}
            primaryText={invite.email}
          />
        ))}
      </List>
    </>
  );
};

export default InvitationsTab;
